import React, { useMemo } from "react";
import FunctionHeader from "../../components/Header/FunctionHeader";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import DocumentFilesGrid from "presentation/components/DocumentFiles/DocumentFilesGrid";
import { TabPanel, TabView } from "primereact/tabview";
import { useAuthStore } from "presentation/stores/use-auth-store";
import { useRoleByFilter } from "presentation/hooks/use-query-role";
import { RoleInputFilter } from "domain/models/role-input-filter";

const DocumentRegulationsGridPage = () => {
  const rolesAllowed = ["CEO", "Admin"];  
  const { userPermissions } = useAuthStore();
  const { data: rolesData, isLoading: areRolesLoading } = useRoleByFilter({
    limit: 100,
  } as RoleInputFilter);

  const hasAdminTabPermission = useMemo(() => {
    if (!rolesData?.data || !userPermissions) {
      return false;
    }
    const allowedRoleIds = rolesData.data
      .filter((role) => rolesAllowed.includes(role.name))
      .map((role) => role.id);

    return userPermissions.some((permission) =>
      allowedRoleIds.includes(permission.roleId)
    );
  }, [rolesData, userPermissions]);
    const {isLoading} = usePermissionCheck({ requiredFunction: "regulations" });
    if (isLoading) {
        return <Spinner />;
    }
    return (
        <div>
            <FunctionHeader title="Regulamentos" />
            <TabView>
                <TabPanel header="Regulamentos" leftIcon="pi pi-book mr-2">
                    <DocumentFilesGrid mode="user" type="regulations" />
                </TabPanel>
                    {hasAdminTabPermission && [
                <TabPanel header="Administração" leftIcon="pi pi-cog mr-2">
                    <DocumentFilesGrid mode="admin" type="regulations" />
                </TabPanel>]}
            </TabView>
        </div>
    );
};
export default DocumentRegulationsGridPage;